module.exports = __webpack_public_path__ + "static/media/rentalIcon.70f36c75.svg";